export function createApiUrl(defaultUrl: string): string {
  // Need to check whether window.location exists because it might be undefined in node/jest
  // environments causing unnecessary errors.
  const originUrl = typeof window !== 'undefined' && window.location ? window.location.origin : '';

  if (originUrl.includes(`blaze.tech`)) {
    return defaultUrl;
  }
  return originUrl ? `${originUrl}/api` : defaultUrl;
}
